import type { SportsEnum } from 'types/generated/client';
import type { LatLng } from 'screens/Find/geo';

export interface MarketplaceLinkParams {
  sport?: SportsEnum;
  /** The first picked neighborhood, or null to let the marketplace resolve the viewer. */
  center?: LatLng | null;
}

/**
 * Carries Home's sport and searched point into a marketplace: every marketplace reads
 * `sport` from the URL, and the geo context seeds itself from `lat`/`lng`.
 */
export const marketplaceUrl = (
  href: string,
  { sport, center }: MarketplaceLinkParams = {},
): string => {
  const [path, existing] = href.split('?');
  const query = new URLSearchParams(existing ?? '');

  if (sport) query.set('sport', sport.toLowerCase());
  if (center) {
    query.set('lat', center.lat.toFixed(6));
    query.set('lng', center.lng.toFixed(6));
  }

  const search = query.toString();
  return search ? `${path}?${search}` : path;
};
